import { z } from 'zod';

import { schemaSkagAuthError, schemaSkagFieldValidationError } from './SkagError';

export const schemaCreditApplicationSuccessResponse = z.object({
    internal_id: z.number(),
    status: z.string(),
    success: z.literal(true),
    timestamp: z.string(),
});

export type SchemaCreditApplicationSuccessResponse = z.infer<typeof schemaCreditApplicationSuccessResponse>;

export const schemaCreditApplicationResponse = z.union([
    schemaCreditApplicationSuccessResponse,
    schemaSkagFieldValidationError,
    schemaSkagAuthError,
]);

export type SchemaCreditApplicationResponse = z.infer<typeof schemaCreditApplicationResponse>;
